import { Capacitor } from '@capacitor/core';
import SmartBanner from 'smart-app-banner';
import 'smart-app-banner/dist/smart-app-banner.css';

export const configureSmartBannerInstallApp = () => {
    if (!Capacitor.isNativePlatform() && !window.location.href.includes('redirect-cobas-plus')) {
        new SmartBanner({
            daysHidden: 7,
            daysReminder: 15,
            title: 'Cobas Área Privada',
            author: 'Cobas A.M.',
            button: 'Ir a App',
            store: {
                ios: 'En la App Store',
                android: 'En Google Play'
            },
            price: {
                ios: 'GRATIS',
                android: 'GRATIS',
                windows: 'GRATIS'
            }
        });
    }
};
